module.exports = __webpack_public_path__ + "img/US.3865cd77.svg";